export enum Locales {
  EN = 'en',
  EN_US = 'en-US',
  PT = 'pt',
  PT_BR = 'pt-BR',
  ES = 'es',
  ES_ES = 'es-ES'
}
